export enum EGALocations {
  ONLINE_ORDER = 'onlineOrdering',
  DINE_IN = 'dineIn',
}
